module.exports = __webpack_public_path__ + "static/strefy-6dbdbf14b73173ab019906dca0945853.jpg";